import { Dialog, DialogActions, DialogContent, Fab } from '@material-ui/core';
import React from 'react';
import UniversalJsonTable from '../UniversalJsonTable';


export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }
    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    maxWidth={'md'}
                >

                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>

                    <DialogContent>
                        <UniversalJsonTable
                            bilant={this.props.bilant}
                            changeValoare={this.props.changeValoare}
                            onBlurValoare={this.props.onBlurValoare}
                        />

                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}